import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * A QR code as an SVG of dark squares, drawn here from the library's module
 * grid rather than its own markup, so nothing it generates is put in the
 * page as HTML. Error correction M; a four-module quiet zone, as the spec asks.
 */
export function QrCode({ text, label }: { text: string; label: string }) {
  const { size, path } = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    const count = qr.getModuleCount();
    let d = '';
    for (let row = 0; row < count; row++) {
      for (let col = 0; col < count; col++) {
        if (qr.isDark(row, col)) d += `M${col + 4} ${row + 4}h1v1h-1z`;
      }
    }
    return { size: count + 8, path: d };
  }, [text]);
  return (
    <svg className="child-code-qr" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={path} fill="#1d2a20" />
    </svg>
  );
}
